var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102.094,
    height: 84.422,
    viewBox: "0 0 102.094 84.422",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5301",
    "data-name": "Group 5301",
    transform: "translate(-2334.946 -12309.132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-download-cloud",
    "data-name": "Icon feather-download-cloud",
    transform: "translate(2434.524 12391.039) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1331",
    "data-name": "Path 1331",
    d: "M0,0,17.634,17.634,35.269,0",
    transform: "translate(30.9 61.773)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1332",
    "data-name": "Path 1332",
    d: "M0,0V39.677",
    transform: "translate(48.535 39.73)",
    fill: "#000",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1333",
    "data-name": "Path 1333",
    d: "M87.683,66.578A22.043,22.043,0,0,0,74.986,26.5H69.431A35.269,35.269,0,1,0,8.857,58.642",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.c98d9cfe73a8f321fd5d34b7726854ed.svg";
export { ForwardRef as ReactComponent };